<div class="navblock hidden-print">
  <button  (click)="openCreateModal()" class="btnadd">{{'Add report template'|translate}}</button>
</div>
<div class="tablewrap admindrivers">
  <div class="table">
    <table fixedcols="[0, 2]" id="exporttable">
      <tr>
        <th>
            <switch-all-checkbox [items]="objects | groupFilter : filter" />
        </th>
        <th>{{'Name' | translate}}</th>
        <th>{{'Type' | translate}}</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let report of objects | groupFilter : filter">
        <td>
          <input type="checkbox" [(ngModel)]="report.IsChecked"/>
        </td>
        <td>{{report.Name}}</td>
        <td>{{reportTypes.get(report.Type) | translate}}</td>
        <td class="hidden-print">
          <button class="btn_img btn_edit"  title="{{'Edit'|translate}}" (click)="openEditModal(report)"></button>
          <button class="btn_img btn_trush " (click)="deleteObject(report.Id)" title="{{'Delete'|translate}}"></button>
        </td>
      </tr>
    </table>
  </div>
</div>
<app-footer-component (onDeleteSelected)="deleteSelected()" [items]="objects | groupFilter : filter"></app-footer-component>

<template #mgmtDialog></template>
